import { IChicletStyleProps, IChicletStyles } from './Chiclet.types';

export const getStyles = (props: IChicletStyleProps): IChicletStyles => {
  return {
    root: {},
  };
};
